import { InstitutionsAuthorizationApi } from "@/features/accounts/shared/services/institutions-authorization-api";
import { InstitutionsAuthorizationGetRequestModel } from "@/features/accounts/shared/services/institutions-authorization-model";

/// 金融機関サイト認可画面要求
export class InstitutionsAuthorizationService {
  private institutionsAuthorizationApi = new InstitutionsAuthorizationApi();

  /**
   * 金融機関サイト認可画面要求
   */
  public async getInstitutionsAuthorization(param: InstitutionsAuthorizationGetRequestModel) {
    return await this.institutionsAuthorizationApi.getInstitutionsAuthorization(param);
  }
}

